"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var SettingsClearProgressWrapper = function SettingsClearProgressWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "message", _descriptor, _this);
      _initializerDefineProperty(_this, "showMessage", _descriptor2, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "clearStoriesProgress",
      value: function clearStoriesProgress() {
        this.message = 'Your stories progress have been reset.';
        _state.AppUI.authUserStore.clearStoriesProgress({
          data: {
            language_id: _state.AppUI.targetLanguageId
          }
        }, this.afterClearProgress);
      }
    }, {
      key: "clearVocabProgress",
      value: function clearVocabProgress() {
        this.message = 'Your vocab trainer progress have been reset.';
        _state.AppUI.authUserStore.clearVocabProgress({
          data: {
            language_id: _state.AppUI.targetLanguageId
          }
        }, this.afterClearProgress);
      }
    }, {
      key: "clearGenderProgress",
      value: function clearGenderProgress() {
        this.message = 'Your gender progress have been reset.';
        _state.AppUI.authUserStore.clearGenderProgress({
          data: {
            language_id: _state.AppUI.targetLanguageId
          }
        }, this.afterClearProgress);
      }
    }, {
      key: "clearPluralProgress",
      value: function clearPluralProgress() {
        this.message = 'Your plural progress have been reset.';
        _state.AppUI.authUserStore.clearPluralProgress({
          data: {
            language_id: _state.AppUI.targetLanguageId
          }
        }, this.afterClearProgress);
      }
    }, {
      key: "clearNumberProgress",
      value: function clearNumberProgress() {
        this.message = 'Your number progress have been reset.';
        _state.AppUI.authUserStore.clearNumberProgress({
          data: {
            language_id: _state.AppUI.targetLanguageId
          }
        }, this.afterClearProgress);
      }
    }, {
      key: "clearConjugationProgress",
      value: function clearConjugationProgress() {
        this.message = 'Your conjugation progress have been reset.';
        _state.AppUI.authUserStore.clearConjugationProgress({
          data: {
            language_id: _state.AppUI.targetLanguageId
          }
        }, this.afterClearProgress);
      }
    }, {
      key: "clearTriviaProgress",
      value: function clearTriviaProgress() {
        this.message = 'Your trivia progress have been reset.';
        _state.AppUI.authUserStore.clearTriviaProgress({
          data: {
            language_id: _state.AppUI.targetLanguageId
          }
        }, this.afterClearProgress);
      }
    }, {
      key: "deleteAllReviews",
      value: function deleteAllReviews() {
        this.message = 'Your reviews have been deleted.';
        _state.AppUI.deckStore.deleteAllReviewCards({
          data: {
            language_id: _state.AppUI.targetLanguageId
          }
        }, this.afterClearProgress);
      }
    }, {
      key: "clearLeagueProgress",
      value: function clearLeagueProgress() {
        this.message = 'Your league progress have been reset.';
        _state.AppUI.authUserStore.clearLeagueProgress({
          data: {
            language_id: _state.AppUI.targetLanguageId
          }
        }, this.afterClearProgress);
      }
    }, {
      key: "afterClearProgress",
      value: function afterClearProgress() {
        var _this2 = this;
        _state.AppUI.loadUser();
        this.showMessage = true;
        setTimeout(function () {
          return _this2.showMessage = false;
        }, 3000);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({
          message: this.message,
          showMessage: this.showMessage,
          clearStoriesProgress: this.clearStoriesProgress,
          clearVocabProgress: this.clearVocabProgress,
          clearGenderProgress: this.clearGenderProgress,
          clearPluralProgress: this.clearPluralProgress,
          clearNumberProgress: this.clearNumberProgress,
          clearConjugationProgress: this.clearConjugationProgress,
          clearTriviaProgress: this.clearTriviaProgress,
          deleteAllReviews: this.deleteAllReviews,
          clearLeagueProgress: this.clearLeagueProgress
        }, this.props));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "message", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "showMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "clearStoriesProgress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearStoriesProgress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearVocabProgress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearVocabProgress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearGenderProgress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearGenderProgress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearPluralProgress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearPluralProgress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearNumberProgress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearNumberProgress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearConjugationProgress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearConjugationProgress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearTriviaProgress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearTriviaProgress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deleteAllReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "deleteAllReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearLeagueProgress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearLeagueProgress"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterClearProgress", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterClearProgress"), _class2.prototype), _class2)) || _class;
};
SettingsClearProgressWrapper.displayName = 'SettingsClearProgressWrapper';
var _default = exports["default"] = SettingsClearProgressWrapper;